import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

import { onMounted } from "vue";
import { useTheme } from "@/hooks";
import { AppNav } from "@/components";


/**
 * Renders the SAFA app.
 */
const __default__ = {
  name: "App",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const theme = useTheme();

onMounted(() => {
  theme.loadDarkMode();
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_q_page_container = _resolveComponent("q-page-container")!
  const _component_q_layout = _resolveComponent("q-layout")!

  return (_openBlock(), _createBlock(_component_q_layout, {
    view: "lHh LpR lfr",
    class: "bg-background"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(AppNav)),
      _createVNode(_component_q_page_container, null, {
        default: _withCtx(() => [
          _createVNode(_component_router_view, null, {
            default: _withCtx(({ Component }) => [
              (_openBlock(), _createBlock(_KeepAlive, null, [
                (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
              ], 1024))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})